//------ 右侧面板事件 开始------
/**
 * 编辑器右侧面板事件定义。
 *
 * 说明：
 * 1. 本文件只定义事件名称、事件原因与载荷结构；
 * 2. cad-core 不持有 web-client 的右侧面板状态，具体切换由订阅方完成。
 */

/**
 * 编辑器右侧面板事件名称枚举。
 */
export enum EditorPanelEventName {
    /** 请求右侧面板显示设计树。 */
    ShowDesignTreeRequested = 'editorPanelShowDesignTreeRequested',
    //------ 视口选择显示属性面板 开始------
    /** 请求右侧面板显示属性面板。 */
    ShowPropertyRequested = 'editorPanelShowPropertyRequested',
    //------ 视口选择显示属性面板 结束------
}

/**
 * 请求显示设计树的原因枚举。
 */
export enum EditorPanelShowDesignTreeReason {
    /** CAD 命令已经确认并退出。 */
    CommandConfirmed = 'command-confirmed',
    /** CAD 命令已经取消并退出。 */
    CommandCanceled = 'command-canceled',
    /** CAD 命令已经自然完成并退出。 */
    CommandFinished = 'command-finished',
    //------ 草图空选显示设计树 开始------
    /** 草图普通编辑态空白点击或空框选后清理了属性面板目标。 */
    SelectionCleared = 'selection-cleared',
    //------ 草图空选显示设计树 结束------
}

//------ 视口选择显示属性面板 开始------
/**
 * 请求显示属性面板的原因枚举。
 */
export enum EditorPanelShowPropertyReason {
    /** 视口单选或 Ctrl 多选已经完成选择结算。 */
    SelectionUpdated = 'selection-updated',
    /** 视口框选已经完成选择结算。 */
    BoxSelectionUpdated = 'box-selection-updated',
    /** 剖面视图命令已经打开或重新进入属性编辑。 */
    SectionViewCommandOpened = 'section-view-command-opened',
}
//------ 视口选择显示属性面板 结束------

/**
 * 请求显示设计树的事件载荷。
 */
export interface EditorPanelShowDesignTreeRequestedEventPayload {
    /** 本次请求的触发原因。 */
    readonly reason: EditorPanelShowDesignTreeReason;
    /** 触发请求时正在收口的命令标识。 */
    readonly command: string | null;
}

//------ 视口选择显示属性面板 开始------
/**
 * 请求显示属性面板的事件载荷。
 */
export interface EditorPanelShowPropertyRequestedEventPayload {
    /** 本次请求的触发原因。 */
    readonly reason: EditorPanelShowPropertyReason;
    /** 本次选择中的主对象 ID。 */
    readonly primaryObjectId: string | null;
    /** 本次选择中的对象数量。 */
    readonly selectedObjectCount: number;
}
//------ 视口选择显示属性面板 结束------

/**
 * 编辑器右侧面板事件注册列表。
 */
export const editorPanelEventNames: IEventBus.CadEventName[] = [
    EditorPanelEventName.ShowDesignTreeRequested,
    //------ 视口选择显示属性面板 开始------
    EditorPanelEventName.ShowPropertyRequested,
    //------ 视口选择显示属性面板 结束------
];
//------ 右侧面板事件 结束------
